export function ErrorIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M10.5003 1.66663C5.90033 1.66663 2.16699 5.39996 2.16699 9.99996C2.16699 14.6 5.90033 18.3333 10.5003 18.3333C15.1003 18.3333 18.8337 14.6 18.8337 9.99996C18.8337 5.39996 15.1003 1.66663 10.5003 1.66663ZM10.5003 10.8333C10.042 10.8333 9.66699 10.4583 9.66699 9.99996V6.66663C9.66699 6.20829 10.042 5.83329 10.5003 5.83329C10.9587 5.83329 11.3337 6.20829 11.3337 6.66663V9.99996C11.3337 10.4583 10.9587 10.8333 10.5003 10.8333ZM11.3337 14.1666H9.66699V12.5H11.3337V14.1666Z"
        fill="currentColor"
      />
    </svg>
  )
}
